export default __webpack_public_path__ + "static/media/clocked-out.5dfc1e04.svg";